import { HotelBookingAttemptsProvider } from 'hotel/bookingAttempts';
import { Navigate, Route, Routes } from 'hotel/navigation';

import SelfBooking from 'pages/SelfBooking';

const SelfBookingRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <HotelBookingAttemptsProvider>
            <SelfBooking />
          </HotelBookingAttemptsProvider>
        }
      />
      <Route path="*" element={<Navigate to="/selfbooking" />} />
    </Routes>
  );
};

export default SelfBookingRoutes;
